import { List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ConversationQuickAction } from '../../ConversationQuickAction';
import { I18nNamespace } from '~/common/types';
import { useQuickActions } from '~/components/ConversationContextProvider/ConversationContextProvider.hook';

interface ConversationStarterActionsProps {
  showQuickActions: boolean;
}

export const ConversationStarterActions = ({ showQuickActions }: ConversationStarterActionsProps) => {
  const { t } = useTranslation(I18nNamespace.conversation, { keyPrefix: 'StarterActions' });
  const { quickActions, onSubmit } = useQuickActions();

  const conversationStarters = quickActions.filter(({ isConversationStarter }) => isConversationStarter);

  return (
    <>
      <Typography variant="body1">{t('actions', { count: conversationStarters.length })}</Typography>
      <List sx={{ '& > li': { margin: 2 } }}>
        {showQuickActions &&
          conversationStarters.map((action) => (
            <ConversationQuickAction key={action.id} action={action} onSubmit={onSubmit} />
          ))}
      </List>
    </>
  );
};
